/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Final property reference selected by the backend for a staff response.
 */
export type PropertyDisplayCode = {
    /**
     * Selected code, preserving external punctuation, case and leading zeros.
     */
    value: string;
    /**
     * Origin of the selected value; internal identifiers remain unchanged.
     */
    source: PropertyDisplayCode.source;
    /**
     * Whether external was requested but the internal code had to be used.
     */
    isFallback: boolean;
};
export namespace PropertyDisplayCode {
    /**
     * Origin of the selected value; internal identifiers remain unchanged.
     */
    export enum source {
        COMOS = 'comos',
        EXTERNAL = 'external',
    }
}

